// keys in this object are constants which are saved as user.testimonials.headers
// each item is an array of [singular, plural]

const headers = {
    '0': ['Testimonial', 'Testimonials'],
    '1': ['Recommendation', 'Recommendations'],
    '2': ['Endorsement', 'Endorsements'],
    '3': ['What clients say about me', 'What clients say about me'],
}

function getTestimonialsHeader({ header, items, singular, plural } = {}) {
    const [singular_text, plural_text] = headers[header] || headers[0]
    if (singular) return singular_text
    if (plural) return plural_text
    if (items && items.length === 1) return singular_text
    return plural_text
}

module.exports = {
    headers,
    getTestimonialsHeader,
}
